import React from 'react';

export const tempInfo = [
  {
    title: 'Bulk Screening',
    paragraph:
        'Screen multiple entries of people & companies or commodities & HS codes.',
    svgIcon: (
      <svg xmlns='http://www.w3.org/2000/svg' width='19' height='19' viewBox='0 0 19 19' fill='none'>
        <g clipPath='url(#clip0_4001_8675)'>
          <path d='M2 9.18749L9.23167 12.8033C9.33006 12.8525 9.37925 12.8771 9.43085 12.8868C9.47655 12.8954 9.52345 12.8954 9.56915 12.8868C9.62075 12.8771 9.66994 12.8525 9.76833 12.8033L17 9.18749M2 12.9375L9.23167 16.5533C9.33006 16.6025 9.37925 16.6271 9.43085 16.6368C9.47655 16.6454 9.52345 16.6454 9.56915 16.6368C9.62075 16.6271 9.66994 16.6025 9.76833 16.5533L17 12.9375M2 5.43749L9.23167 1.82165C9.33006 1.77246 9.37925 1.74786 9.43085 1.73818C9.47655 1.72961 9.52345 1.72961 9.56915 1.73818C9.62075 1.74786 9.66994 1.77246 9.76833 1.82165L17 5.43749L9.76833 9.05332C9.66994 9.10252 9.62075 9.12711 9.56915 9.13679C9.52345 9.14537 9.47655 9.14537 9.43085 9.13679C9.37925 9.12711 9.33006 9.10252 9.23167 9.05332L2 5.43749Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
        </g>
        <defs>
          <clipPath id='clip0_4001_8675'>
            <rect width='18' height='18' fill='white' transform='translate(0.5 0.1875)'/>
          </clipPath>
        </defs>
      </svg>
    ),
    headers: [ '' ],
  },
  {
    title: 'Screen Bill of Materials',
    paragraph:
        'Upload your Bill of Materials for screening and submit for risk analysis.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='19'
        viewBox='0 0 18 19'
        fill='none'
      >
        <g id='file-search-02' clipPath='url(#clip0_4134_429)'>
          <path
            id='Icon'
            d='M10.5 8.4375H6M7.5 11.4375H6M12 5.4375H6M15 8.0625V5.2875C15 4.02738 15 3.39732 14.7548 2.91602C14.539 2.49266 14.1948 2.14845 13.7715 1.93274C13.2902 1.6875 12.6601 1.6875 11.4 1.6875H6.6C5.33988 1.6875 4.70982 1.6875 4.22852 1.93274C3.80516 2.14845 3.46095 2.49266 3.24524 2.91602C3 3.39732 3 4.02738 3 5.2875V13.0875C3 14.3476 3 14.9777 3.24524 15.459C3.46095 15.8823 3.80516 16.2265 4.22852 16.4423C4.70982 16.6875 5.33988 16.6875 6.6 16.6875H8.625M16.5 16.6875L15.375 15.5625M16.125 13.6875C16.125 15.1372 14.9497 16.3125 13.5 16.3125C12.0503 16.3125 10.875 15.1372 10.875 13.6875C10.875 12.2378 12.0503 11.0625 13.5 11.0625C14.9497 11.0625 16.125 12.2378 16.125 13.6875Z'
            stroke='#4895EF'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_4134_429'>
            <rect
              width='18'
              height='18'
              fill='white'
              transform='translate(0 0.1875)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    headers: [ 'Item', 'Assembly Name or Number', 'Sub Assembly Name or Number', 'Component / Part Name', 'Part Number', 'Description', 'Quantity', 'Unit', 'Unit Cost' ],
  },
  {
    title: 'Screen Bill of Lading',
    paragraph:
        'Upload your Bill of Lading for screening and submit for risk analysis.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='19'
        viewBox='0 0 18 19'
        fill='none'
      >
        <g clipPath='url(#clip0_4134_3746)'>
          <path
            d='M15 9.5625V5.2875C15 4.02738 15 3.39732 14.7548 2.91602C14.539 2.49266 14.1948 2.14845 13.7715 1.93274C13.2902 1.6875 12.6601 1.6875 11.4 1.6875H6.6C5.33988 1.6875 4.70982 1.6875 4.22852 1.93274C3.80516 2.14845 3.46095 2.49266 3.24524 2.91602C3 3.39732 3 4.02738 3 5.2875V13.0875C3 14.3476 3 14.9777 3.24524 15.459C3.46095 15.8823 3.80516 16.2265 4.22852 16.4423C4.70982 16.6875 5.33988 16.6875 6.6 16.6875H9M10.5 8.4375H6M7.5 11.4375H6M12 5.4375H6M10.875 14.4375L12.375 15.9375L15.75 12.5625'
            stroke='#4895EF'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_4134_3746'>
            <rect
              width='18'
              height='18'
              fill='white'
              transform='translate(0 0.1875)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    headers: [ 'Invoice Number', 'Purchase Order Number', 'Shipper Company Name', 'Shipper Address', 'Shipper City', 'Shipper State/Province', 'Shipper Country', 'Shipper Zip Code', 'Shipper Contact Name', 'Shipper Phone', 'Shipper Email', 'Consignee Company Name', 'Consignee Address', 'Consignee City', 'Consignee State/Province', 'Consignee Country', 'Consignee Zip Code', 'Consignee Contact Name', 'Consignee Phone', 'Consignee Email', 'Carrier Name', 'Carrier Address', 'Carrier Contact Name', 'Carrier Phone', 'Carrier Email', 'Description of Goods', 'HS Code', 'Quantity', 'Weight', 'Dimensions', 'Freight Class', 'Hazerdous Material', 'Hazardous Material UN Number', 'Country of Origin', 'Value of Goods', 'Incoterms', 'Shipping Instructions', 'Special Conditions', 'Mode of Transport', 'Origin Port/Location', 'Date of Pickup', 'Vessel/Flight Number', 'Destination Port/Location', 'Estimated Delivery Date', 'Freight Charges', 'Payment Terms', 'Customs Broker Name', 'Customs Broker Phone', 'Customs Broker Email' ],
  },
  {
    title: 'Supplier Questionnaire',
    paragraph:
        'Upload your questionnaire, submit to your supplier, and screen the return.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='19'
        viewBox='0 0 18 19'
        fill='none'
      >
        <g clipPath='url(#clip0_4134_3757)'>
          <path
            d='M10.5 1.88965V4.98755C10.5 5.40759 10.5 5.61761 10.5817 5.77805C10.6537 5.91917 10.7684 6.0339 10.9095 6.10581C11.0699 6.18755 11.28 6.18755 11.7 6.18755H14.7979M7.38748 9.18918C7.51963 8.81352 7.78046 8.49675 8.12378 8.29498C8.4671 8.09321 8.87075 8.01945 9.26324 8.08678C9.65573 8.1541 10.0117 8.35815 10.2682 8.6628C10.5246 8.96745 10.665 9.35304 10.6644 9.75126C10.6644 10.8754 8.97817 11.4375 8.97817 11.4375M9 13.6875H9.0075M10.5 1.6875H6.6C5.33988 1.6875 4.70982 1.6875 4.22852 1.93274C3.80516 2.14845 3.46095 2.49266 3.24524 2.91602C3 3.39732 3 4.02738 3 5.2875V13.0875C3 14.3476 3 14.9777 3.24524 15.459C3.46095 15.8823 3.80516 16.2265 4.22852 16.4423C4.70982 16.6875 5.33988 16.6875 6.6 16.6875H11.4C12.6601 16.6875 13.2902 16.6875 13.7715 16.4423C14.1948 16.2265 14.539 15.8823 14.7548 15.459C15 14.9777 15 14.3476 15 13.0875V6.1875L10.5 1.6875Z'
            stroke='#4895EF'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_4134_3757'>
            <rect
              width='18'
              height='18'
              fill='white'
              transform='translate(0 0.1875)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    headers: [ 'Name of Facility',	'Address of Facility',	'Contact Name',	'Contact Title',	'Parent Company', '	Facility Owners',	'Subcontractors (If Applicable)' ],
  },
  {
    title: 'ACE Entry Summary',
    paragraph:
        'Upload your ACE Entry Summary to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'Entry Number', 'Importer of Record Number', 'Exporter Name', 'Exporter Address', 'Port of Entry', 'Entry Date', 'Entry Type', 'Carrier Name', 'Country of Origin', 'Commodity Harmonized Tariff Code (HTS)', 'Value', 'Quantity', 'Tariff Classification', 'Duty and Fees', 'Mode of Transport', 'Container Number(s)', 'Certificate of Origin', 'Trade Agreement (If Applicable)' ],
  },
  {
    title: 'Screen Drawback (DB)',
    paragraph:
        'Upload your Drawback to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'Drawback Number', 'Importer of Record', 'Exporter Name', 'Drawback Type', 'Entry Date', 'Export Date', 'HS Code', 'Quantity and Value', 'Port of Export', 'Bond Information', 'Certification of Export/Destruction', 'Refund Requested', 'Shipment Tracking Number', 'Refund Amount' ],
  },
  {
    title: 'Foreign Trade Zone',
    paragraph:
        'Upload your Foreign Trade Zone to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'FTZ Number', 'Importer of Record', 'Zone Admission Number', 'Zone Status (Privileged, Non-Privileged, etc.)', 'Entry Number', 'HS Code', 'Quantity and Value', 'Location of Goods in FTZ', 'Manufacturing or Processing Activity', 'Certification of Admission', 'Certification of Removal', 'Zone Approval Officer' ],
  },
  {
    title: 'Global Buisness ID',
    paragraph:
        'Upload your Global Buisness ID to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'Company Legal Name', 'Company Identification Number', 'Parent Company (If applicable)', 'Address', 'Country of Operation', 'Global Identifier Type', 'Certification of Registration', 'Contact Person Information', 'Company Website' ],
  },
  {
    title: 'Importer Security Filing',
    paragraph:
        'Upload your Importer Security Filing to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'Importer Security Filing Number', 'Importer of Record Name', 'Importer of Record Address', 'Consignee Number', 'Buyer Name', 'Buyer Address', 'Seller Name', 'Seller Address', 'Manufacturer Name', 'Manufacturer Address', 'Ship To Party', 'Container Stuffing Location', 'Consolidator (Stuffer) Name', 'Consolidator (Stuffer) Address', 'Country of Origin', 'Commodity Harmonized Tariff Schedule Number (HTS)', 'Product Detailed Information', 'Vessel Name', 'Voyage Number', 'Master SCAC Code', 'AMS SCAC Code', 'Master Bill Number', 'AMS Bill Number', 'Estimated Sailing Date', 'Estimated Date of Arrival', 'Carrier\'s Information', 'Importer Reference Numbers' ],
  },
  {
    title: 'Screen In-Bond',
    paragraph:
        'Upload your In-Bond to BITE and run a check for any possible issues.',
    svgIcon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M9.75 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75H9.75M12.75 5.25H14.1C14.9401 5.25 15.3601 5.25 15.681 5.41349C15.9632 5.5573 16.1927 5.78677 16.3365 6.06901C16.5 6.38988 16.5 6.80992 16.5 7.65V10.35C16.5 11.1901 16.5 11.6101 16.3365 11.931C16.1927 12.2132 15.9632 12.4427 15.681 12.5865C15.3601 12.75 14.9401 12.75 14.1 12.75H12.75M12.75 15.75L12.75 2.25M14.625 2.25001L10.875 2.25M14.625 15.75L10.875 15.75'
          stroke='#4895EF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
    headers: [ 'In-Bond Control Number', 'Importer of Record', 'Carrier Identification Code', 'Vessel Name or Aircraft', 'Port of Export', 'Port of Destination', 'Bonded Carrier\'s ID', 'In-Bond Type', 'Description of Merchandise', 'HS Code', 'Quantity and Weight', 'Customs Officer Signature', 'Expected Arrival Date', 'Estimated Time of Departure' ],
  },

];
